/* ============================================================
   model-card.js — Buy on the model cards

   The variant list is a compatibility list, not a chooser: the cap is
   the same part for every drone in a product's range, so the entries
   are there to show the customer that their model is covered. Nothing
   about them is clickable, and Buy does not wait for a pick - it adds
   the product's own default variant.

   The add itself follows the theme's own product-form.js: a POST to
   routes.cart_add_url carrying the section ids the cart drawer or the
   cart notification wants back, then handing the response to whichever
   of the two the shop is configured for.
   ============================================================ */
(() => {
  const cartElement = () =>
    document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  const addToCart = (variantId, buy) => {
    const cart = cartElement();
    const body = new FormData();
    body.append('id', variantId);
    body.append('quantity', 1);
    if (cart) {
      body.append('sections', cart.getSectionsToRender().map((section) => section.id));
      body.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
    }

    buy.setAttribute('aria-busy', 'true');
    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          // Sold out, or the variant no longer exists. There is nowhere to send the
          // customer - the shop has no product pages in use - so the refusal is
          // recorded and the button simply becomes usable again.
          console.warn('[model-card] cart refused the variant:', data.description || data.message);
          return;
        }
        // No drawer and no notification configured: the theme falls back to the
        // cart page, same as its own add-to-cart forms do.
        if (cart) cart.renderContents(data);
        else window.location = (window.routes && window.routes.cart_url) || '/cart';
      })
      .catch((err) => console.error('[model-card] add to cart failed', err))
      .finally(() => buy.removeAttribute('aria-busy'));
  };

  document.addEventListener('click', (event) => {
    const buy = event.target.closest('[data-nh-buy]');
    if (!buy) return;

    const variantId = buy.dataset.nhVariant;
    // Without a variant id there is nothing to add.
    if (!variantId) return;

    addToCart(variantId, buy);
  });
})();
